<template>
  <div style="height: 100vh;" :class="{ 'no-scroll': noScroll }">
    <v-app-bar v-if="!noTopBar" fixed class="top-bar">
      <no-membership-top-bar v-if="orgIsUndefined" />
      <the-top-bar v-else />
    </v-app-bar>
    <v-navigation-drawer
      v-if="hasToolbox"
      fixed
      right
      :width="`${rightToolboxWidth}px`"
      :mini-variant-width="
        rightToolboxIsMini ? `${rightToolboxMiniWidth}px` : `${rightToolboxWidth}px`
      "
      :mini-variant="true"
      mobile-breakpoint="0"
      class="pad-top"
    >
      <slot name="toolbox" />
    </v-navigation-drawer>
    <v-navigation-drawer
      v-if="hasLeftNav"
      :key="mini"
      fixed
      left
      :width="`${leftNavWidth}px`"
      :mini-variant-width="leftNavIsMini ? `${leftNavMiniWidth}px` : `${leftNavWidth}px`"
      :expand-on-hover="leftNavIsMini && leftNavExpandOnHover"
      :mini-variant.sync="mini"
      mobile-breakpoint="0"
      class="pad-top"
      @update:mini-variant="onInput"
    >
      <slot name="left-nav" />
    </v-navigation-drawer>
    <v-main :style="mainStyle">
      <v-layout id="main-root" column>
        <v-flex v-if="hasFullSubheader" :class="{ 'pad-top': !noTopBar }">
          <slot id="subheader-bordered" name="subheader-bordered" />
        </v-flex>
        <v-flex v-if="hasSmallSubheader" :class="{ 'pad-top': !hasFullSubheader && !noTopBar }">
          <slot id="subheader" name="subheader" />
        </v-flex>
        <v-flex
          id="main-default"
          :class="{ 'pad-top': !hasFullSubheader && !hasSmallSubheader && !noTopBar }"
        >
          <slot name="default" />
        </v-flex>
      </v-layout>
    </v-main>
  </div>
</template>

<script>
import NoMembershipTopBar from '@/components/layout/NoMembershipTopBar'
import TheTopBar from '@/components/layout/TheTopBar'
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import _ from 'lodash'

export default {
  components: {
    TheTopBar,
    NoMembershipTopBar
  },
  props: {
    contentBackgroundColor: { type: String, default: 'white' },
    fullHeight: { type: Boolean, default: false },
    leftNavWidth: { type: Number, default: 400 },
    noLeftPadding: { type: Boolean, default: false },
    noScroll: { type: Boolean, default: false },
    noRightPadding: { type: Boolean, default: false },
    noTopBar: { type: Boolean, default: false },
    padTop: { type: Number, default: undefined },
    rightToolboxWidth: { type: Number, default: 330 },
    rightToolboxMiniWidth: { type: Number, default: 48 },
    rightToolboxIsMini: { type: Boolean, default: false },
    leftNavExpandOnHover: { type: Boolean, default: false },
    leftNavMiniWidth: { type: Number, default: 25 },
    leftNavIsMini: { type: Boolean, default: false }
  },
  data() {
    return {
      mini: undefined,
      drawerOpen: this.open
    }
  },
  computed: {
    themeContentBackground() {
      return _.get(this.$vuetify.theme.themes.light, this.contentBackgroundColor, 'white')
    },
    computeLeftNavWidth() {
      return this.leftNavIsMini ? this.leftNavMiniWidth : this.leftNavWidth
    },
    computeRightToolboxWidth() {
      return this.rightToolboxIsMini ? this.rightToolboxMiniWidth : this.rightToolboxWidth
    },
    addLeftPadding() {
      return this.noLeftPadding ? 0 : 10
    },
    leftPadding() {
      return this.hasLeftNav
        ? `${this.computeLeftNavWidth + this.addLeftPadding}px`
        : `${this.addLeftPadding}px`
    },
    addRightPadding() {
      return this.noRightPadding ? 0 : 10
    },
    rightPadding() {
      return this.hasToolbox
        ? `${this.computeRightToolboxWidth + this.addRightPadding}px`
        : `${this.addRightPadding}px`
    },
    mainStyle() {
      const style = {
        backgroundColor: this.themeContentBackground,
        paddingLeft: this.leftPadding,
        paddingRight: this.rightPadding
      }
      if (this.padTop) {
        style.paddingTop = `${this.padTop}px`
      }
      style.minHeight = this.fullHeight ? '100%' : 'initial'
      return style
    },
    hasFullSubheader() {
      return this.hasSlot('subheader-bordered')
    },
    hasSmallSubheader() {
      return this.hasSlot('subheader')
    },
    hasToolbox() {
      return this.hasSlot('toolbox')
    },
    hasLeftNav() {
      return this.hasSlot('left-nav')
    },
    orgIsUndefined() {
      return _.isUndefined(MyActiveOrganization?.type)
    }
  },
  watch: {
    open(newVal) {
      this.drawerOpen = newVal
    }
  },
  methods: {
    hasSlot(name) {
      const slot = this.$slots[name]
      return !_.isNull(slot) && !_.isUndefined(slot)
    },
    onInput(isClosed) {
      this.$emit('leftNavClosed', isClosed)
    }
  }
}
</script>

<style lang="scss" scoped>
.subheader-bordered {
  border-bottom: solid 1px var(--v-lightTwo-base);
}

.pad-top {
  padding-top: 64px;
}

.no-scroll {
  overflow-y: hidden !important;
}
</style>
